import { lazy } from 'react';

const ProcessorPreferences = lazy(() => import('./ProcessorPreferencesPage'));

const ProcessorPreferencesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'processor/preferences',
      element: <ProcessorPreferences />,
    },
  ],
};

export default ProcessorPreferencesConfig;
